// extracted by mini-css-extract-plugin
export default {"table_header":"styles_table_header__WlFZD","white_header":"styles_white_header__T7Q-I"};